'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$ItemsLoaded(items) {
  this.KW = null;
  this.KW = items;
}
export { $c_Lpresto_crud$ItemsLoaded as $c_Lpresto_crud$ItemsLoaded };
$p = $c_Lpresto_crud$ItemsLoaded.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$ItemsLoaded;
/** @constructor */
function $h_Lpresto_crud$ItemsLoaded() {
}
export { $h_Lpresto_crud$ItemsLoaded as $h_Lpresto_crud$ItemsLoaded };
$h_Lpresto_crud$ItemsLoaded.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_crud$ItemsLoaded)) {
    var x = this.KW;
    var x$2 = x$0.KW;
    return ((x === null) ? (x$2 === null) : x.i(x$2));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ItemsLoaded";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KW;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$ItemsLoaded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jd)));
}
export { $isArrayOf_Lpresto_crud$ItemsLoaded as $isArrayOf_Lpresto_crud$ItemsLoaded };
var $d_Lpresto_crud$ItemsLoaded = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$ItemsLoaded, "presto.crud$ItemsLoaded", ({
  jd: 1,
  bw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$ItemsLoaded as $d_Lpresto_crud$ItemsLoaded };
//# sourceMappingURL=presto.crud$-Items-Loaded.js.map
